import { registerBlockType } from "@wordpress/blocks";

import { Fragment } from "@wordpress/element";

import {
    InnerBlocks, 
} from "@wordpress/editor";

const { __ } = wp.i18n;

registerBlockType("wp-naat-goals-list-block/goals-list-block", {
    title: __("Naat Block de liste d'objectifs", 'naat-editor-tools'),
    description: __("Paramètres de la liste d'objectifs", 'naat-editor-tools'),
    icon: "list-view",
    category: "widgets",
    attributes: {
        text: { type: "string" },
    },
    edit({ attributes, setAttributes }) {        
        return (
            <Fragment>
                <h3>{__("Block de liste d'objectifs", 'naat-editor-tools')}</h3>
                <p>Insert an list block just below</p>
                <InnerBlocks
                    allowedBlocks={ 'core/list '}
                />
            </Fragment>
        );
    },
    save() {
        return (
            <div
            className="naat-goals-list">
                    <InnerBlocks.Content />
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/javascript/naat_goals_list_block.jsx